import Vue from 'vue'
import VueRouter from 'vue-router'
import OrderManagement from '../views/OrderManagement.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/orders'
  },
  {
    path: '/orders',
    name: 'orders',
    component: OrderManagement
  },
  {
    path: '/products',
    name: 'products',
    component: () => import(/* webpackChunkName: "products" */ '../views/ProductManagement.vue')
  },
  {
    path: '/customers',
    name: 'customers',
    component: () => import(/* webpackChunkName: "customers" */ '../views/CustomerManagement.vue')
  },
  {
    path: '/statistics',
    name: 'statistics',
    component: () => import(/* webpackChunkName: "statistics" */ '../views/StatisticsView.vue')
  },  
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/debug',
    name: 'debug',
    component: () => import(/* webpackChunkName: "debug" */ '../views/DebugView.vue')
  }
]

const router = new VueRouter({
  mode: 'hash', // 企业微信环境必须使用hash模式
  base: process.env.BASE_URL,
  routes
})

export default router
